import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { gridCubeVariants } from "../utilities/customHooks";

function ProjectList({ image, name, content, tags, id }) {
  const navigate = useNavigate();
  return (
    <motion.div className="project" variants={gridCubeVariants}>
      <div className="desc">
        <h4>{name}</h4>
        <p>{content}</p>
        <div className="tags">
          {tags.map((tag, i) => {
            return <p key={i}>{tag}</p>;
          })}
        </div>
        <a
          className="btn cta"
          onClick={() => {
            navigate("/project/" + id);
          }}
        >
          {/* <span className="vertical"></span>
          <span className="horizontal"></span>View Details */}
          View Details
        </a>
      </div>
      <img src={image} alt="Thumbnail" />
    </motion.div>
  );
}

export default ProjectList;
